import { defineMessages } from 'react-intl';

/** The SoundCloud card of Catalog → Sources (SoundCloud connector design a). */
export const soundCloudCardMessages = defineMessages({
  name: { id: 'app.sml.soundcloud.card.name', defaultMessage: 'SoundCloud' },
  notConnected: { id: 'app.sml.soundcloud.card.notConnected', defaultMessage: 'not connected' },
  noteNotConnected: {
    id: 'app.sml.soundcloud.card.note.notConnected',
    defaultMessage: 'Read your plays, likes and reposts every day.',
  },
  noteAutoUpload: {
    id: 'app.sml.soundcloud.card.note.alsoUpload',
    defaultMessage: 'MUSIC24 can also upload your songs to SoundCloud.',
  },
  waiting: { id: 'app.sml.soundcloud.card.waiting', defaultMessage: 'Waiting for SoundCloud' },
  noteConnecting: {
    id: 'app.sml.soundcloud.card.note.connecting',
    defaultMessage: 'Sign in on SoundCloud and allow MUSIC24. Then you come back here.',
  },
  opening: { id: 'app.sml.soundcloud.card.opening', defaultMessage: 'Opening SoundCloud' },
  connectedAs: { id: 'app.sml.soundcloud.card.connectedAs', defaultMessage: 'connected · {name}' },
  noteFirstRead: {
    id: 'app.sml.soundcloud.card.note.firstRead',
    defaultMessage: 'Reading your tracks. The first read takes a few minutes.',
  },
  waitingFirstSync: { id: 'app.sml.soundcloud.card.waitingFirstSync', defaultMessage: 'Waiting for the first sync' },
  noteConnected: {
    id: 'app.sml.soundcloud.card.note.connected',
    defaultMessage: 'Plays, likes, reposts and comments of your tracks, read every day.',
  },
  noteCanUpload: {
    id: 'app.sml.soundcloud.card.note.canUpload',
    defaultMessage: 'MUSIC24 can upload your songs here.',
  },
  signedOut: { id: 'app.sml.soundcloud.card.signedOut', defaultMessage: 'signed out' },
  noteReconnect: {
    id: 'app.sml.soundcloud.card.note.reconnect',
    defaultMessage: 'SoundCloud signed MUSIC24 out. Reconnect to keep your numbers up to date.',
  },
  noteReconnectStop: {
    id: 'app.sml.soundcloud.card.note.reconnectStop',
    defaultMessage: 'Your numbers stop at {day}.',
  },
  lastSync: { id: 'app.sml.soundcloud.card.lastSync', defaultMessage: 'Last sync {day}' },
  pillSignedOut: { id: 'app.sml.soundcloud.card.pill.signedOut', defaultMessage: 'Signed out' },
  failed: {
    id: 'app.sml.soundcloud.card.failed',
    defaultMessage: 'SoundCloud did not finish the sign-in. Nothing changed. Try again.',
  },
  connect: { id: 'app.sml.soundcloud.card.connect', defaultMessage: 'Connect' },
  tryAgain: { id: 'app.sml.soundcloud.card.tryAgain', defaultMessage: 'Try again' },
  cancel: { id: 'app.sml.soundcloud.card.cancel', defaultMessage: 'Cancel' },
  reconnect: { id: 'app.sml.soundcloud.card.reconnect', defaultMessage: 'Reconnect' },
  syncNow: { id: 'app.sml.soundcloud.card.syncNow', defaultMessage: 'Sync now' },
  disconnect: { id: 'app.sml.soundcloud.card.disconnect', defaultMessage: 'Disconnect' },
  verified: { id: 'app.sml.soundcloud.card.verified', defaultMessage: 'Verified' },
  // Disconnect (a4)
  disconnectEyebrow: { id: 'app.sml.soundcloud.disconnect.eyebrow', defaultMessage: 'Service connections' },
  disconnectTitle: { id: 'app.sml.soundcloud.disconnect.title', defaultMessage: 'Disconnect SoundCloud?' },
  disconnectBody: {
    id: 'app.sml.soundcloud.disconnect.body',
    defaultMessage:
      'MUSIC24 stops reading your SoundCloud numbers and cannot upload songs there. The numbers we read stay in Streaming. The tracks on SoundCloud stay too.',
  },
  disconnectWaiting: {
    id: 'app.sml.soundcloud.disconnect.waiting',
    defaultMessage: '{count, plural, one {1 upload waits.} other {# uploads wait.}}',
  },
  disconnectWaitingCancels: {
    id: 'app.sml.soundcloud.disconnect.waitingCancels',
    defaultMessage: '{count, plural, one {Disconnect cancels it.} other {Disconnect cancels them.}}',
  },
  disconnectWaitingCancelsList: {
    id: 'app.sml.soundcloud.disconnect.waitingCancelsList',
    defaultMessage: '{count, plural, one {Disconnect cancels it} other {Disconnect cancels them}}: {songs}.',
  },
  disconnectSong: { id: 'app.sml.soundcloud.disconnect.song', defaultMessage: '{title} ({date})' },
  disconnectKeep: { id: 'app.sml.soundcloud.disconnect.keep', defaultMessage: 'Keep it' },
  disconnectConfirm: { id: 'app.sml.soundcloud.disconnect.confirm', defaultMessage: 'Disconnect' },
  disconnectConfirmCancel: {
    id: 'app.sml.soundcloud.disconnect.confirmCancel',
    defaultMessage: 'Disconnect and cancel {count}',
  },
});
